import React from "react";
import TopHeader from "../../../components/header/TopHeader";
import quizBanner from "../../../../../styles/img/quiz-banner.png";
import { UiBannerBottomBar } from "../../../components/common/UiBannerBottomBar";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import Footer from "../../../components/footer/Footer";
import TropyStar from '../../../../../styles/img/tropystar.png';
import { Button } from "react-bootstrap";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import KnowledgeInnerBaner from "../Views/KnowledgeInnerBanner";
import { UiBlueBox } from "../../../../_uiComponents/common/UiBlueBox";
import { QuestionLinks } from "../../../../_uiComponents/common/QuestionLinks";
import { CircleTickGreenFill } from "../../../../../styles/img/svg/CircleGreenFill";
import { UiGrayBox } from "../../../../_uiComponents/common/UiGrayBox";
import { UiHowItWorks } from "../../../components/common/UiHowCampaignsWork";
import { CourceSlider } from "./Views/CourceSlider";
import hcw1 from "../../../../../styles/img/hcw-1.png";
import hcw2 from "../../../../../styles/img/hcw-2.png";
import hcw3 from "../../../../../styles/img/hcw-3.png";


export const CourseInProgress = () => {

    const HowCourceWorks = [
        { 'id': '1', 'heading': 'Step 1', 'description': 'Ut enim ad minim veniam, quis nostrud exercitation ullamco ', 'icon': hcw1 },
        { 'id': '2', 'heading': 'Step 2', 'description': 'Ut enim ad minim veniam, quis nostrud exercitation ullamco ', 'icon': hcw2 },
        { 'id': '3', 'heading': 'Step 2', 'description': 'Ut enim ad minim veniam, quis nostrud exercitation ullamco ', 'icon': hcw3 }
    ]


    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Volvo 4x4 Programme"
                    description="Let’s sharpen up your knowledge with fast informative quiz!"
                    sliderCardImage={quizBanner}
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="   Volvo 4x4 Quiz"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-quiz-main-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-quiz-main-page__links">
                                    <QuestionLinks>
                                        <li className="active"><a href="#"><CircleTickGreenFill />  About Course</a></li>
                                        <li><a href="#">Contents</a></li>
                                        <li><a href="#">Need to know</a></li>
                                    </QuestionLinks>

                                </UiCol>
                                <UiCol lg="9" className="sb-quiz-main-page__content">
                                    <h3>About This Quiz</h3>
                                    <h4>Title</h4>

                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <p>  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                                    <UiGrayBox>
                                        <UiSingleRow className="sb-ip-crs">
                                            <UiCol lg="3" className="sb-quiz-main-page-bb sb-qr-bx">
                                                <UiBlueBox >
                                                    <div>
                                                        <p>Questions Remaining</p>
                                                        <h3>4/15</h3>
                                                    </div>
                                                </UiBlueBox>
                                            </UiCol>

                                            <UiCol lg="3" className="sb-quiz-main-page-bb sb-orange-box">
                                                <UiBlueBox >
                                                    <img src={TropyStar} />
                                                    <h3>Badge Available</h3>
                                                </UiBlueBox>
                                            </UiCol>

                                            <UiCol lg="6">
                                                <h2>Course In Progress</h2>
                                                <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                    tempor incididunt ut ero labore et dolore magna aliqua. </p>
                                                <Button className="sb-orange-btn">Resume?</Button>
                                            </UiCol>
                                        </UiSingleRow>

                                    </UiGrayBox>

                                    <h3>Contents</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.  </p>

                                    <CourceSlider slides={3} />

                                    <h3>Need to know</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.  </p>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiHowItWorks title="How Courses Work" HowItWorksItems={HowCourceWorks} />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <Footer />

            </UiMainWrapper>


        </>
    )
}